export default __webpack_public_path__ + "static/media/selloPagado.20cc65c4.png";